'use client';

import { useMediaData } from '@frameio/shared/contexts';
import { useActiveViewableAssetId } from '@frameio/shared/hooks';
import { ToggleIconButton, Tooltip } from '@frameio/vapor';
import { IconCompareLinkVertical } from '@frameio/vapor-icons';
import { usePremierePlayheadSyncStatus } from '../hooks/usePremierePlayheadSyncStatus';
import TEXT from './generated/TEXT/PremierePlayheadSyncButton';

TEXT.DEFINE({
  /** Label to sync Frame.io and Premiere playheads */
  playheadSync: 'Sync Playhead with Timeline',
});

export function PremierePlayheadSyncButton() {
  const assetId = useActiveViewableAssetId();
  const mediaData = useMediaData();
  const {
    canSyncPlayhead,
    onPlayheadSyncClick,
    playheadSyncEnabled,
    isLoading,
  } = usePremierePlayheadSyncStatus();

  const isVideo = mediaData?.__typename === 'VideoMedia';
  const isAudio = mediaData?.__typename === 'AudioMedia';
  const isSupportedMedia = isVideo || isAudio;

  if (!assetId || !canSyncPlayhead || !isSupportedMedia) {
    return null;
  }

  return (
    <Tooltip placement="top" title={TEXT.playheadSync}>
      <ToggleIconButton
        icon={<IconCompareLinkVertical />}
        isDisabled={isLoading || playheadSyncEnabled === undefined}
        isSelected={playheadSyncEnabled === true}
        label={TEXT.playheadSync}
        onClick={onPlayheadSyncClick}
        size="small"
        variant="dimmed"
      />
    </Tooltip>
  );
}
